// list of all constants in the application

export const arrayOfAge = [15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30];

export const arrayOfBranch = [
    "B.Tech I.T.",
    "B.Tech F.T.",
    "B.Tech A.G.",
    "B.Tech CIVIL"
];


export const arrayOfGender = ["Male", "Female", "Other"];


export const arrayOfAdmissionSession = [
    "2014-2015", "2015-2016", "2016-2017", "2017-2018",
    "2018-2019", "2019-2020", "2020-2021", "2021-2022",
    "2022-2023", "2023-2024", "2024-2025", "2025-2026",
    "2026-2027", "2027-2028", "2028-2029", "2029-2030",
    "2030-2031", "2031-2032", "2032-2033", "2033-2034",
    "2034-2035","2035-2036", "2036-2037", "2037-2038",
];


export const arrayOfSemester = [
    "First Semester",
    "Second Semester",
    "Third Semester",
    "Fourth Semester",
    "Fifth Semester",
    "Sixth Semester",
    "Seventh Semester",
    "Eighth Semester"
];

export const courseFeeType = [
    "Study Trip Fee",
    "Tuition Fee",
    "Laboratory/Computer Fee",
    "Delay Fee",
    "Security Fee",
    "Hostel Fee",
    "Other Charges",
    "Entrance Fees",
    "Central Library Fee",
    "Student Smart Card Fee",
    "Sports and Cultural Program Fee",
    "Student Welfare Fee",
    "Development Fee",
    "Student Academic Guide",
    "Examination Fee",
    "Energy Charges",
    "Internet Fee",
    "Total Fee"
];